import * as React from 'react';
import { BeatLoader } from 'react-spinners';
import '../matchesView.css';
import SidebarContainer from 'src/modules/Routing/Sidebar/SidebarContainer';
import Match from 'src/modules/Recognition/Match/Match';
import { Location } from 'history';
import { match } from 'react-router';
import { RoutesModules } from 'src/modules/Routing/types';

export interface IMatchInfoProps {
  history: any;
  match: match<{
    caseId: string;
    childId: string;
    searchId: string;
    matchId: string;
  }>;
  agencies: any;
  location: Location;
}

export interface IMatchInfoState {
  loading: boolean;
}

export class MatchInfo extends React.Component<
  IMatchInfoProps,
  IMatchInfoState
> {
  constructor(props: IMatchInfoProps) {
    super(props);
    this.state = {
      loading: true,
    };
  }

  public isLoading = (loading: boolean) => {
    this.setState({ loading });
  };

  public render() {
    const { pathname } = this.props.location;
    const type = pathname.includes('adhoc')
      ? 'adhoc'
      : pathname.includes('biometrica')
      ? 'biometrica'
      : pathname.includes('webiq')
      ? 'webiq'
      : 'gmcngine';
    return (
      <div className="match-info-container">
        <Match
          match={this.props.match}
          type={type}
          isLoading={this.isLoading}
          loading={this.state.loading}
          history={this.props.history}
        />
        <div className="help-loader">
          <BeatLoader loading={this.state.loading} />
        </div>
      </div>
    );
  }
}

export default SidebarContainer(RoutesModules.SEARCH)(MatchInfo);



// WEBPACK FOOTER //
// ./src/modules/AdHocTools/Matches/components/MatchInfo.tsx